function createUUID() {
  let dt = new Date().getTime();

  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  return uuid;
}

function contains(selector, text) {
  const elements = document.querySelectorAll(selector);

  return [].filter.call(elements, (element) => {
    return RegExp(text).test(element.textContent);
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('keyup', this.onInputChange.bind(this));
    this.updateButtonState();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    this.updateButtonState();
  }

  onInputChange() {
    if (this.input.value < 1) {
      this.input.value = 1;
    } else if (this.input.value > 100) {
      this.input.value = 100;
    }
    this.updateButtonState();
  }

  updateButtonState() {
    if (this.input.value <= 1) {
      this.minusButton.ariaDisabled = true;
      this.minusButton.classList.add('disabled');
    } else {
      this.minusButton.ariaDisabled = false;
      this.minusButton.classList.remove('disabled');
    }

    if (this.input.value >= 100) {
      this.plusButton.ariaDisabled = true;
      this.plusButton.classList.add('disabled');
    } else {
      this.plusButton.ariaDisabled = false;
      this.plusButton.classList.remove('disabled');
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    // Select main details element, excluding .mobile-menu__accordion
    this.mainDetailsToggle = this.querySelector('details:not(div.mobile-menu__accordion details)');
    this.closeButton = this.querySelector('.navigation-header_close');

    // iPhone viewport height fix
    let platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown';
    if (platform === 'iPhone') {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    // Event listeners for keyboard and focus events
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach(
      (button) =>
        !button.classList.contains('navigation-header_back') &&
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

    // Escape key close event
    document.addEventListener('keydown', this.handleEscapeKey.bind(this));

    // Close button click event
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.closeMenuDrawer(null, this.mainDetailsToggle.querySelector('summary'));
      });
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape' && this.mainDetailsToggle.hasAttribute('open')) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    }
  }

  onSummaryClick(event) {
    if (event.currentTarget.parentNode.parentNode.classList.contains('mobile-menu__accordion'))
      return;

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    // always reset to the mainDrawer before closing or the plusDrawer will stay visible if it was opened
    showDrawer(mainDrawer);
    // Set aria-expanded to false
    if (elementToFocus) elementToFocus.setAttribute('aria-expanded', 'false');
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      ) {
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', 'false');
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const video = this.querySelector('video');
      if (this.classList.contains('product__modal-opener--video')) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      } else {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
      if (deferredElement.nodeName == 'VIDEO') {
        // Add an event listener to the video element to toggle play/pause on click
        deferredElement.addEventListener('click', () => {
          if (deferredElement.paused) {
            deferredElement.play();
          } else {
            deferredElement.pause();
          }
        });
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.dotButtonsWrapperMobile = this.querySelector('.slider-dots--mobile');
    this.dotButtonsWrapperDesktop = this.querySelector('.slider-dots--desktop');

    if (window.innerWidth < 989) {
      this.dotButtonsWrapper = this.dotButtonsWrapperMobile;
    } else {
      this.dotButtonsWrapper = this.dotButtonsWrapperDesktop;
    }

    if (this.dotButtonsWrapper) {
      this.allDotButtons = this.dotButtonsWrapper.querySelectorAll('.dot');
      this.allDotButtons.forEach((dot) =>
        dot.addEventListener('click', this.onDotClick.bind(this))
      );
    }

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );

    if (this.sliderItemsToShow.length < 2) return;

    // Calculate the gap between the slider items
    this.sliderItemsGap =
      this.sliderItemsToShow[1].offsetLeft -
      (this.sliderItemsToShow[0].offsetLeft + this.sliderItemsToShow[0].clientWidth);
    // Calculate the width of one slider item
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // Calculate the width of one slider item - the gap
    this.sliderItemOffsetMinusGap =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft -
      this.sliderItemsGap;
    // Calculate the number of slides that fit in the slider
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffsetMinusGap);
    // Calculate the total number of pages to scroll through before you reach the end
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  onDotClick(event) {
    // Get the index of the clicked dot button
    const dotIndex = Array.from(this.allDotButtons).indexOf(event.currentTarget);
    // Calculate the index of the slide to scroll to
    const slideIndex = dotIndex * this.slidesPerPage;
    // Calculate the target scroll position of the slider
    this.slideScrollPosition = this.sliderItemsToShow[slideIndex].offsetLeft;

    // Scroll to the target slide
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  /**
   * Updates the slider component based on the current scroll position.
   * This function calculates the current page, updates the page counter,
   * shows/hides dot buttons based on the total page count, and dispatches
   * a custom event when the slide changes.
   */
  update() {
    // Store the previous page for comparison
    const previousPage = this.currentPage;

    // Calculate the current page based on the scroll position
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    // Update the page counter if elements exist
    if (this.currentPageElement && this.pageTotalElement) {
      // Calculate the total page count based on visible slides
      const totalPageCount = Array.from(this.sliderItems).filter(
        (element) => !element.classList.contains('hidden')
      ).length;

      // Update the current page and total page count elements
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = totalPageCount;

      // Check if dotButtonsWrapper exists
      if (this.dotButtonsWrapper) {
        // Show/hide product media gallery dot buttons based on the total page count for the current variant
        const dots = this.dotButtonsWrapper.querySelectorAll('.dot');
        dots.forEach((dot) => {
          const page = parseInt(dot.dataset.page, 10);
          if (page <= totalPageCount) {
            dot.classList.remove('hidden');
          } else {
            dot.classList.add('hidden');
          }
        });
      }
    }

    // Dispatch a custom event when the slide changes
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    // Disable/enable previous and next buttons if not looping
    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Update the active dot button
    debounce(() => {
      if (!this.allDotButtons) return;
      this.allDotButtons.forEach((dot) => dot.classList.remove('active'));
      const activeDotButton = this.allDotButtons[this.currentPage - 1];
      if (activeDotButton) activeDotButton.classList.add('active');
    }, 250).bind(this)();
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const activeSliderItems = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    const step = event.currentTarget.dataset.step || 1;
    let element = activeSliderItems[this.currentPage - step];

    // Pause a video when changing slides
    if (element && element.querySelector('video')) {
      const video = element.querySelector('video');
      video.pause();
    }

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });

    // Play a video when changing slides
    if (event.currentTarget.name === 'next') {
      element = activeSliderItems[this.currentPage - step + 1];
    } else {
      element = activeSliderItems[this.currentPage - step - 1];
    }
    if (element && element.querySelector('video')) {
      const video = element.querySelector('video');
      video.play();
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.toggleDynamicContentBlocks();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateStickyAtcDataAttribute();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  toggleDynamicContentBlocks() {
    const allDynamicContentBlocks = document.querySelectorAll('.dynamic-variant-content-block');

    allDynamicContentBlocks.forEach((block) => {
      if (block.dataset.variantId == this.currentVariant.id) block.classList.add('active');
      else block.classList.remove('active');
    });
  }

  updateStickyAtcDataAttribute() {
    const stickyAtc = document.querySelector('.product-form__submit.sticky-atc');
    if (!stickyAtc) return false;

    if (this.currentVariant.available) {
      stickyAtc.dataset.oos = '0';
    } else {
      stickyAtc.dataset.oos = '1';
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    } else {
      return;
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);

    if (this.dataset.section.indexOf('__main') > -1) {
      if (document.querySelector('.product--stacked') != null) {
        var elements = document
          .querySelector('.product--stacked')
          .querySelectorAll('.thumb-alt-hide');
        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            elements[i].classList.add('hidden');
          }
          var element = document
            .querySelector('.product--stacked')
            .querySelectorAll(
              '.thumbnail-alt-' + this.currentVariant.featured_media.alt.replace('#', '')
            );
          for (let j = 0; j < element.length; j++) {
            element[j].classList.remove('hidden');
          }
        }
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        const text = this.currentVariant.available
          ? window.variantStrings.addToCart
          : window.variantStrings.soldOut;
        this.toggleAddButton(!this.currentVariant.available, text, true);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtons = productForm.querySelectorAll('[name="add"]');
    if (addButtons.length === 0) return;

    addButtons.forEach((button) => {
      this.updateButton(button, disable, text);
    });

    if (!modifyClass) return;
  }

  updateButton(button, disable, text) {
    if (!button) return;

    const spinner = button.querySelector('.loading-overlay__spinner');
    const buttonText = button.querySelector('span') || button;

    if (disable) {
      button.setAttribute('disabled', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');

      if (spinner) {
        spinner.classList.remove('hidden');
      }
    } else {
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.classList.remove('loading');

      if (spinner) {
        spinner.classList.add('hidden');
      }
    }

    // Ensure button text updates correctly
    if (text !== undefined) {
      buttonText.textContent = text;
    } else {
      buttonText.textContent = disable
        ? window.variantStrings.soldOut
        : window.variantStrings.addToCart;
    }

    // Prevent infinite loading state by hiding the spinner after updating the text
    if (spinner && !disable) {
      spinner.classList.add('hidden');
    }
  }

  setUnavailable() {
    this.toggleAddButton(true, window.variantStrings.unavailable, true);

    const price = document.getElementById(`price-${this.dataset.section}`);
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/*
Variant Selects are used whenever rebuy-quick-add is used in the product card ir featured sections
*/

class VariantSwatches extends VariantSelects {
  constructor() {
    super();
    this.wrapper = this.closest('.card-wrapper');
    this.featuredImage = this.wrapper.querySelector('#primary_image');
    this.hoverImage = this.wrapper.querySelector('#secondary_image');
    this.addToCartButton = this.wrapper.querySelector('[data-rebuy-add]');
    this.spinner = this.addToCartButton?.querySelector('.loading-overlay__spinner');
    this.productLinks = this.wrapper.querySelectorAll('.card__link');
    this.hasMultipleOptions = false;
    this._originalButton = this.addToCartButton;

    this.querySelectorAll('input').forEach((input) =>
      input.addEventListener('change', this.onVariantChange.bind(this))
    );
    this.initRebuyEventListeners();
    this.updateOptions();
    this.updateMasterId();
  }

  initRebuyEventListeners() {
    if (!this.addToCartButton) return;

    this.addToCartButton.addEventListener('click', (event) => {
      if (this.addToCartButton.hasAttribute('disabled')) {
        event.preventDefault();
        return;
      }
      this.updateButton(this.addToCartButton, true, window.variantStrings.addingToCart);
      this.rebuySubmit(event);
    });

    document.addEventListener('rebuy:smartcart.show', () => {
      this.updateButton(this.addToCartButton, false, window.variantStrings.addToCart);
    });
  }

  onVariantChange(event) {
    event.stopImmediatePropagation();
    this.swatch = event.target.closest('[data-variant-swatch]');
    this.hasMultipleOptions = this.swatch.dataset.multipleOptions === 'true';

    if (this.hasMultipleOptions) {
      this.renderProductInfo(event);
    } else {
      this.updateOptions();
      this.updateMasterId();
      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.renderProductInfo(event);
      }
    }
  }

  renderProductInfo(event) {
    try {
      const { product_id, image, secondary_image, url } = this.swatch.dataset;
      if (!product_id || !image) throw new Error('Missing data attributes');

      if (product_id === this.featuredImage.dataset.current_id) {
        this.updateMedia(image, secondary_image);
        this.updateProductLinks(url);
      }
    } catch (error) {
      console.error(`Error: ${error.message}`);
    } finally {
      if (!this.hasMultipleOptions) {
        this.currentVariant.available ? this.inStock() : this.outOfStock();
      }
    }
  }

  outOfStock() {
    console.log('out of stock');
    this.updateButton(this.addToCartButton, true, window.variantStrings.soldOut);
    this.showBackInStockButton();
  }

  inStock() {
    console.log('in stock');
    this.updateButton(this.addToCartButton, false, window.variantStrings.addToCart);
    this.removeBackInStockButton();
  }

  showBackInStockButton() {
    const bisScript = document.querySelector('script[src*="app.backinstock.org"]');
    if (!bisScript) return;

    if (!this._originalButton) {
      this._originalButton = this.closest('.card-wrapper').querySelector('.button');
    }
    const buttonParent = this._originalButton.parentNode;
    if (!buttonParent) return;

    buttonParent.removeChild(this._originalButton);

    const productFormAttributes = document
      .getElementById(`product-form-${this.dataset.section}`)
      .closest('[data-product-data]');
    const productData = productFormAttributes.getAttribute('data-product-data');

    const anchor = document.createElement('a');
    anchor.href = '#';
    anchor.className = 'BIS_trigger button';
    anchor.textContent = window.variantStrings.outOfStock;
    anchor.setAttribute('data-product-data', productData);
    buttonParent.appendChild(anchor);
  }

  removeBackInStockButton() {
    const cardWrapper = this.closest('.card-wrapper');
    const anchor = cardWrapper.querySelector('a.BIS_trigger.button');

    if (anchor) {
      const anchorParent = anchor.parentNode;
      anchorParent.removeChild(anchor);
      if (this._originalButton) {
        anchorParent.appendChild(this._originalButton);
      }
    }
  }

  async rebuySubmit(event) {
    event.preventDefault();

    if (!this.currentVariant) return;

    const id = this.currentVariant.id;
    const formData = { items: [{ id, quantity: 1 }] };

    try {
      await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error('Error adding item to cart:', error);
    } finally {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(
      (fieldset) =>
        Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    );
  }

  updateMedia(imageSource, secondaryImageSource) {
    this.featuredImage.srcset = imageSource;
    this.hoverImage.srcset = secondaryImageSource;
  }

  updateProductLinks(url) {
    this.productLinks.forEach((productLink) => {
      productLink.href = url;
    });
  }
}

customElements.define('variant-swatches', VariantSwatches);

var elements = document.querySelectorAll('.multicolumn-card-clickable');
elements.forEach(
  (item) => {
    var url = item.getAttribute('data-card-link');
    item.addEventListener('click', function (e) {
      window.location.href = url;
    });
  },
  {
    passive: true,
  }
);
// Open all external links in a new tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (
    links[i].hostname !== window.location.hostname &&
    !links[i].hostname.includes('loopearplugs.com')
  ) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Custom countdown timer
class Timer extends HTMLElement {
  constructor() {
    super();
    // Initialize timer display elements
    this.timerDisplaySeconds = this.querySelector('custom-timer #timer-seconds');
    this.timerDisplayMinutes = this.querySelector('custom-timer #timer-minutes');
    this.timerDisplayHour = this.querySelector('custom-timer #timer-hours');
    this.timerDisplayDays = this.querySelector('custom-timer #timer-days');
    this.timerDisplayWeeks = this.querySelector('custom-timer #timer-weeks');

    // Get the end date from the dataset
    this.endDate = this.dataset.end;
    if (this.endDate) {
      this.isoDateString = this.parseDateString(this.endDate);
      this.countDownDate = new Date(this.isoDateString).getTime();
    }
  }

  // Interval to update timer every 1 second
  connectedCallback() {
    this.timer = setInterval(() => {
      this.updateCountdownTimer();
    }, 1000);
  }

  // Function to parse the input date string
  parseDateString(inputDateString) {
    // Split the input string into parts (assuming format "MM.DD, YYYY, HH:mm:ss")
    const parts = inputDateString.split(', ');
    // Extract day, month, year, and time
    const day = parseInt(parts[0].split('.')[1]);
    const month = parseInt(parts[0].split('.')[0]) - 1; // Months are zero-based
    const year = parseInt(parts[1]);
    const time = parts[2];

    // Create a Date object with the extracted components
    const dateObject = new Date(year, month, day, ...time.split(':'));
    // Get the ISO formatted date string
    const isoDateString = dateObject.toISOString();
    return isoDateString;
  }

  // Function that updates the countdown timer
  updateCountdownTimer() {
    // Edge case: if the end date isn't defined, define now
    if (!this.endDate) {
      this.endDate = this.dataset.end;
      this.isoDateString = this.parseDateString(this.endDate);
      this.countDownDate = new Date(this.isoDateString).getTime();
    }

    // Edge case: if the elements aren't defined, define now
    if (
      !this.timerDisplaySeconds ||
      !this.timerDisplayMinutes ||
      !this.timerDisplayHour ||
      !this.timerDisplayDays ||
      !this.timerDisplayWeeks
    ) {
      this.timerDisplaySeconds = this.querySelector('custom-timer #timer-seconds');
      this.timerDisplayMinutes = this.querySelector('custom-timer #timer-minutes');
      this.timerDisplayHour = this.querySelector('custom-timer #timer-hours');
      this.timerDisplayDays = this.querySelector('custom-timer #timer-days');
      this.timerDisplayWeeks = this.querySelector('custom-timer #timer-weeks'); // Add weeks element
    }

    // Difference between now and endDate
    let now = new Date().getTime();
    let timeleft = this.countDownDate - now;

    // Calculate weeks, days, hours, minutes, seconds
    const weeks = Math.floor(timeleft / (7 * 24 * 60 * 60 * 1000));
    const days = Math.floor((timeleft % (7 * 24 * 60 * 60 * 1000)) / (24 * 60 * 60 * 1000));
    let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    // Display weeks if more than 1 week, or "week" if exactly one week
    if (weeks > 1) {
      this.timerDisplayWeeks.innerHTML = `${weeks} weeks`;
    } else if (weeks === 1) {
      this.timerDisplayWeeks.innerHTML = `1 week`;
    } else {
      this.timerDisplayWeeks.innerHTML = ''; // No weeks to display
    }

    // Add countdown values for days, hours, minutes, seconds
    this.timerDisplaySeconds.innerHTML = `${seconds}s`;
    this.timerDisplayMinutes.innerHTML = `${minutes}m`;
    this.timerDisplayHour.innerHTML = `${hours}h`;
    this.timerDisplayDays.innerHTML = `${days}d`;

    // Stop the timer and set all values to zero when time is up
    if (timeleft < 0) {
      this.timerDisplayWeeks.innerHTML = ''; // No weeks when timer ends
      this.timerDisplaySeconds.innerHTML = `0s`;
      this.timerDisplayMinutes.innerHTML = `0m`;
      this.timerDisplayHour.innerHTML = `0h`;
      this.timerDisplayDays.innerHTML = `0d`;
      clearInterval(this.timer); // Stop the countdown
    }
  }

  // Clean up when the element is disconnected
  disconnectedCallback() {
    clearInterval(this.timer); // Clear the interval when the element is removed from the DOM
  }
}

// Define the custom element
customElements.define('custom-timer', Timer);

document.addEventListener(
  'quizKitQuestionLoaded',
  function (e) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          const counterElement = document.querySelector('#quiz-kit-container h3');
          if (counterElement) {
            function updatePercentage(element) {
              // Extract the content of the h3 element
              const content = element.textContent.trim();

              // Use a regular expression to extract the numbers
              const numbers = content.match(/\d+/g);

              if (numbers && numbers.length === 2) {
                const current = parseInt(numbers[0], 10);
                const total = parseInt(numbers[1], 10);
                const quizWrapper = document.getElementById('quiz-kit-content');
                const isBiggerThan1024 = window.matchMedia('(min-width: 1025px)').matches;

                // Check if total is not zero to avoid division by zero
                if (total !== 0) {
                  if (current > 1) {
                    if (isBiggerThan1024) {
                      quizWrapper.style.width = '442px';
                      quizWrapper.style.margin = 'auto';
                    }
                    // Inject the progress bar HTML below the h3 element if it doesn't already exist
                    if (!document.querySelector('#progress-container')) {
                      const progressBarHTML = `
                                            <div id="progress-container">
                                                <div id="progress-bar"></div>
                                            </div>`;
                      element.insertAdjacentHTML('afterend', progressBarHTML);
                    }

                    // Calculate the percentage
                    const percentage = (current / total) * 100;
                    const percentageText =
                      percentage % 1 === 0 ? `${percentage}%` : `${percentage.toFixed(2)}%`;
                    // Replace the content with the percentage
                    element.textContent = percentageText + ' completed';

                    // Update the progress bar width
                    const progressBar = document.getElementById('progress-bar');
                    progressBar.style.width = `${percentage}%`;
                  } else {
                    // Hide the h3 element on the first step
                    element.style.display = 'none';
                    quizWrapper.style.width = 'initial';
                  }
                } else {
                  // Handle case where total is zero
                  element.textContent = `0% completed`;
                  const progressBar = document.getElementById('progress-bar');
                  progressBar.style.width = '0%';
                }
              } else {
                console.error('Failed to extract numbers from the content:', content);
              }
            }

            // Call the function to update the percentage
            updatePercentage(counterElement);

            observer.disconnect();
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
  false
);

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

/* Mobile navigation */
// Main elements and variables
const mainDrawer = document.getElementById('main-drawer');
const plusDrawer = document.getElementById('plus-drawer');
const linkGroupDrawer = document.getElementById('link-group-drawer');
const linkListDrawer = document.getElementById('link-list-drawer');
const backButton = document.querySelector('.navigation-header_back');
const navigationHeader = document.querySelector('.navigation-header');
const mobileNavLogo = document.querySelector('.navigation-header .mobile_nav-logo');
let currentDrawer = 'main'; // Track current drawer state

// Function to show and hide specific drawers
function showDrawer(drawer) {
  [mainDrawer, plusDrawer, linkGroupDrawer, linkListDrawer].forEach(
    (d) => (d.style.display = 'none')
  );
  drawer.style.display = 'block';

  // Back button visibility and justifyContent spacing
  if (drawer === mainDrawer) {
    backButton.classList.add('set_hidden');
    mobileNavLogo.classList.remove('set_hidden');
  } else {
    backButton.classList.remove('set_hidden');
    mobileNavLogo.classList.add('set_hidden');
  }

  trapFocus(drawer.closest('#menu-drawer'), drawer);

  currentDrawer = drawer.id;
}

// Event listener setup
document.addEventListener('DOMContentLoaded', () => {
  // Back button functionality
  if (backButton) {
    backButton.addEventListener('click', (e) => {
      e.preventDefault();
      goBack();
    });
  }

  // Event listener for plus items
  document.querySelectorAll('.menu-drawer_item--plus').forEach((item) => {
    const productId = item.getAttribute('data-product-id');
    if (productId) {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        openPlusDrawer(productId);
      });
    }
  });

  // Event listener for link group items with data-block-id
  document.querySelectorAll('.menu-drawer_item--link-group').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const blockId = item.getAttribute('data-block-id');
      openLinksDrawer(blockId);
    });
  });
});

// Open Plus Drawer
function openPlusDrawer(productId) {
  const plusDrawerList = plusDrawer.querySelector('.menu-drawer_list');
  plusDrawerList.innerHTML = ''; // Clear content

  const mainProductElement = document
    .querySelector(`[data-product-id="${productId}"]`)
    ?.closest('li')
    ?.cloneNode(true);
  if (mainProductElement) {
    mainProductElement.querySelector('a').href = mainProductElement
      .querySelector('a')
      .getAttribute('data-product-url');
    plusDrawerList.appendChild(mainProductElement);
  }

  const plusProductElement = document.getElementById(`plus-product-${productId}`)?.cloneNode(true);
  if (plusProductElement) {
    plusProductElement.style.display = 'block';
    plusDrawerList.appendChild(plusProductElement);
  }

  showDrawer(plusDrawer);
}

// Open Link Group Drawer
function openLinksDrawer(blockId) {
  const linkDrawerList = linkGroupDrawer.querySelector('.menu-drawer_list');
  linkDrawerList.innerHTML = ''; // Clear content

  // Select only link-group-content items with the matching block ID
  document
    .querySelectorAll(`.menu-drawer_item--link-group-content[data-block-id="${blockId}"]`)
    .forEach((item) => {
      const clonedItem = item.cloneNode(true);
      clonedItem.style.display = 'flex';
      linkDrawerList.appendChild(clonedItem);
    });

  // Add click listener to the appended `.link-list-trigger`
  const linkListTrigger = linkDrawerList.querySelector(
    `.link-list-trigger[data-block-id="${blockId}"]`
  );
  if (linkListTrigger) {
    linkListTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openLinkListDrawer(blockId); // Pass blockId to open specific link list
    });
  }

  showDrawer(linkGroupDrawer);
}

// Open Link List Drawer
function openLinkListDrawer(blockId) {
  const linkListDrawerList = linkListDrawer.querySelector('.menu-drawer_list');
  linkListDrawerList.innerHTML = ''; // Clear content

  // Select only link_list items with the matching block ID
  document
    .querySelectorAll(`.menu-drawer_item--link_list[data-block-id="${blockId}"]`)
    .forEach((item) => {
      const clonedItem = item.cloneNode(true);
      clonedItem.style.display = 'block';
      linkListDrawerList.appendChild(clonedItem);
    });

  showDrawer(linkListDrawer);
}

// Back Navigation
function goBack() {
  if (currentDrawer === 'link-list-drawer') {
    // Go back from link-list-drawer to link-group-drawer
    showDrawer(linkGroupDrawer);
  } else if (currentDrawer === 'link-group-drawer') {
    // Go back from link-group-drawer to main-drawer
    showDrawer(mainDrawer);
  } else if (currentDrawer === 'plus-drawer') {
    // Go back from plus-drawer to main-drawer
    showDrawer(mainDrawer);
  }
}

/*=============== Rebuy CO Button disabled state fix ===============*/
document.addEventListener('rebuy:smartcart.ready', (event) => {
  const smartcart = event.detail.smartcart;
  const checkoutButton = smartcart.cartElement.querySelector('.rebuy-cart__checkout-button');

  if (!checkoutButton) return;

  const buttonObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'disabled' &&
        checkoutButton.classList.contains('rebuy-cart__checkout-button--force-active')
      ) {
        checkoutButton.disabled = false;
      }
    });
  });
  buttonObserver.observe(checkoutButton, {
    attributes: true,
    attributeFilter: ['disabled'],
  });

  let forceActiveTimeout;
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\/change/.test(entry.name);
      if (isValidRequestType && isCartChangeRequest) {
        // Clear any existing timeout
        if (forceActiveTimeout) {
          clearTimeout(forceActiveTimeout);
        }

        checkoutButton.disabled = false;
        checkoutButton.classList.add('rebuy-cart__checkout-button--force-active');
        forceActiveTimeout = setTimeout(() => {
          console.log('removing force active');
          checkoutButton.classList.remove('rebuy-cart__checkout-button--force-active');
        }, 1000);
      }
    });
  });
  cartObserver.observe({ entryTypes: ['resource'] });
});

/*=============== Rebuy upsell horizontal scroll ===============*/

document.addEventListener('rebuy:smartcart.show', () => {
  const upsellWrapper = document.querySelector('.upsell_wrapper');
  const leftButton = document.querySelector('.slider-btn.left');
  const rightButton = document.querySelector('.slider-btn.right');
  const blockWidth = upsellWrapper.querySelector('.rebuy-product-block').offsetWidth + 8; // Include any gap/margin

  // Track if the last scroll was right
  let lastScrollWasRight = false;

  // Update button states (enable/disable buttons based on scroll position)
  function updateButtonStates() {
    const scrollLeft = upsellWrapper.scrollLeft;
    const maxScrollLeft = upsellWrapper.scrollWidth - upsellWrapper.clientWidth;

    leftButton.disabled = scrollLeft <= 0;
    rightButton.disabled = scrollLeft >= maxScrollLeft;
  }

  // Scroll left (snap to the previous full card)
  leftButton.addEventListener('click', () => {
    const scrollLeft = upsellWrapper.scrollLeft;

    if (lastScrollWasRight) {
      // If the last scroll was right, handle the partial leftover
      const leftover = scrollLeft % blockWidth;
      if (leftover > 0) {
        // Scroll back the leftover first to realign
        upsellWrapper.scrollTo({ left: scrollLeft - leftover, behavior: 'smooth' });
        lastScrollWasRight = false; // Reset tracker
        return; // Stop further scrolling to avoid jumping
      }
    }

    // Calculate new scroll position for the left scroll
    const newScrollLeft = Math.max(
      0,
      Math.floor(scrollLeft / blockWidth) * blockWidth - blockWidth
    );
    upsellWrapper.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
  });

  // Scroll right (snap to the next full card)
  rightButton.addEventListener('click', () => {
    const scrollLeft = upsellWrapper.scrollLeft;
    const maxScrollLeft = upsellWrapper.scrollWidth - upsellWrapper.clientWidth;

    // Calculate remaining scroll distance
    const remainingScroll = maxScrollLeft - scrollLeft;

    // Ensure no skipping of the penultimate card
    const newScrollLeft =
      scrollLeft + (remainingScroll < blockWidth ? remainingScroll : blockWidth);

    upsellWrapper.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
    lastScrollWasRight = true; // Mark that the last scroll was right
  });

  upsellWrapper.addEventListener('scroll', updateButtonStates);
  updateButtonStates();
});

/*====== accessibility fix for empty alt tags on images ======*/
document.addEventListener('DOMContentLoaded', function () {
  const emptyAltImages = Array.from(document.querySelectorAll('img:not([alt]), img[alt=""]'));
  if (emptyAltImages.length) {
    emptyAltImages.forEach((img) => {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    });
  }
});

/*=============== Open chat from any #openChat href ===============*/
const chatLinks = document.querySelectorAll('a[href="#openChat"]');
chatLinks.forEach((link) => {
  if (typeof window.adaEmbed === 'undefined') {
    //  link.closest(".contact-item").style.display = "none"
  }
  link.addEventListener('click', (e) => {
    e.preventDefault();
    if (window.adaEmbed) window.adaEmbed.toggle();
  });
});

// Add properties to the cart attributes that we need later on in klaviyo.
document.addEventListener('DOMContentLoaded', function () {
  const formData = new FormData();
  formData.append('attributes[__money_format]', Shopify.money_format);
  formData.append('attributes[__currency_rate]', parseFloat(Shopify.currency.rate));

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData,
  });
});

/*=============== Skip to next section ===============*/
document.querySelectorAll('[data-skip-to-next-section]').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const thisSection = e.target.closest('.shopify-section');
    const nextSection = thisSection.nextElementSibling;
    console.log({ nextSection });

    if (nextSection) {
      const focusableElements = getFocusableElements(thisSection);
      let lastFocusableElement = focusableElements[focusableElements.length - 1];

      if (lastFocusableElement) {
        lastFocusableElement.focus();
      } else {
        nextSection.focus();
      }
    }
  });
});
